import React, { FC } from 'react';
import styled from 'styled-components';
import { Profile } from '../index';
import { ProfileFormData } from './ProfileForm';
import { ProfileSettingsAdvancedFormCard } from './ProfileSettingsAdvancedFormCard';

interface Props {
  onSubmit: (values: ProfileFormData) => void;
  profile: Profile;
}

const Styles = styled.div``;

export const ProfileSettingsAdvanced: FC<Props> = ({ onSubmit, profile }): JSX.Element => {
  return (
    <Styles>
      <div className="advanced-settings-card">
        <ProfileSettingsAdvancedFormCard onSubmit={onSubmit} profile={profile} />
      </div>
    </Styles>
  );
};
